"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRole = void 0;
var UserRole;
(function (UserRole) {
    UserRole["PlantOperator"] = "PlantOperator";
    UserRole["VPPOperator"] = "VPPOperator";
    UserRole["External"] = "External";
    UserRole["CuPoOperator"] = "CuPoOperator";
    UserRole["SalesPartner"] = "SalesPartner";
    UserRole["BasicUser"] = "BasicUser";
})(UserRole || (exports.UserRole = UserRole = {}));
